module.exports = __webpack_public_path__ + "static/img/core-item-1.27ea379.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fusionIntegrationPhone/core-item-1.png
// module id = m72u
// module chunks = 0